import menuButton from './menuButton';
import formula from '../global/formula';
import { dynamicArrayHightShow } from '../global/dynamicArray';
import { rowLocationByIndex, colLocationByIndex, rowLocation, colLocation, } from '../global/location';
import browser from '../global/browser';
import dataVerificationCtrl from './dataVerificationCtrl';
import { getSheetIndex, getRangetxt } from '../methods/get';
import Store from '../store';
import method from '../global/method';
import locale from '../locale/locale';
import { refreshMenuButtonFocus } from "../global/api";
import luckysheetConfigsetting from "./luckysheetConfigsetting";
import { getRowValue } from "../utils/util";
import { tabChange } from "./handler";
import numeral from 'numeral';
import { luckysheetrefreshgrid } from '../global/refresh';
//公式函数 选区实体框
function seletedHighlistByindex(id, r1, r2, c1, c2) {
    let row = Store.visibledatarow[r2],
        row_pre = r1 - 1 == -1 ? 0 : Store.visibledatarow[r1 - 1];
    let col = Store.visibledatacolumn[c2],
        col_pre = c1 - 1 == -1 ? 0 : Store.visibledatacolumn[c1 - 1];

    $('#' + id).css({
        "left": col_pre,
        "width": col - col_pre - 1,
        "top": row_pre,
        "height": row - row_pre - 1
    });
}

//Set selection highlight
// 选区高亮
function selectHightlightShow(isRestore = false) {
    $("#luckysheet-cell-selected-boxs").show();
    $("#luckysheet-cell-selected-boxs #luckysheet-cell-selected").siblings(".luckysheet-cell-selected").remove();
    const mergeCol = luckysheetConfigsetting.mergeCol;

    if (Store.luckysheet_select_save.length > 0) {
        // console.log('选区', JSON.parse(JSON.stringify(Store.luckysheet_select_save)), Store.config, mergeCol);
        for (let i = 0; i < Store.luckysheet_select_save.length; i++) {
            let r1 = Store.luckysheet_select_save[i].row[0],
                r2 = Store.luckysheet_select_save[i].row[1];
                
            let c1 = Store.luckysheet_select_save[i].column[0],
                c2 = Store.luckysheet_select_save[i].column[1];
            // console.log('选区坐标', r1, r2, c1, c2, r2- r1);
            if(c2-c1 == luckysheetConfigsetting.customColumnTitles.length - 1 && r2 == r1) {
                if(r1 % 2 == 0) {
                    r2 += 1
                } else {
                    r1 -= 1
                }
            }

            let rf, cf;
            if (Store.luckysheet_select_save[i].row_focus == null) {
                rf = r1;
            }
            else {
                rf = Store.luckysheet_select_save[i].row_focus;
            }

            if (Store.luckysheet_select_save[i].column_focus == null) {
                cf = c1;
            }
            else {
                cf = Store.luckysheet_select_save[i].column_focus;
            }

            let row = Store.visibledatarow[r2],
                row_pre = r1 - 1 == -1 ? 0 : Store.visibledatarow[r1 - 1];
            let col = Store.visibledatacolumn[c2],
                col_pre = c1 - 1 == -1 ? 0 : Store.visibledatacolumn[c1 - 1];

            let row_f = Store.visibledatarow[rf],
                row_pre_f = rf - 1 == -1 ? 0 : Store.visibledatarow[rf - 1];
            let col_f = Store.visibledatacolumn[cf],
                col_pre_f = cf - 1 == -1 ? 0 : Store.visibledatacolumn[cf - 1];

            let margeset = menuButton.mergeborer(Store.flowdata, rf, cf);
            if (!!margeset) {
                row_f = margeset.row[1];
                row_pre_f = margeset.row[0];

                col_f = margeset.column[1];
                col_pre_f = margeset.column[0];
            }

            Store.luckysheet_select_save[i]["row"] = [r1, r2];
            Store.luckysheet_select_save[i]["column"] = [c1, c2];

            Store.luckysheet_select_save[i]["row_focus"] = rf;
            Store.luckysheet_select_save[i]["column_focus"] = cf;

            Store.luckysheet_select_save[i]["left"] = col_pre_f;
            Store.luckysheet_select_save[i]["width"] = col_f - col_pre_f - 1;
            Store.luckysheet_select_save[i]["top"] = row_pre_f;
            Store.luckysheet_select_save[i]["height"] = row_f - row_pre_f - 1;

            Store.luckysheet_select_save[i]["left_move"] = col_pre;
            Store.luckysheet_select_save[i]["width_move"] = col - col_pre - 1;
            Store.luckysheet_select_save[i]["top_move"] = row_pre;
            Store.luckysheet_select_save[i]["height_move"] = row - row_pre - 1;
            let border = Store.luckysheet_select_save.length == 1 ? "1px solid #0188fb" :  "1px solid rgba(1, 136, 251, 0.15)";

            if (i == 0) {
                if (Store.luckysheet_select_save.length == 1) {
                    if (browser.mobilecheck()) {//移动端
                        $("#luckysheet-cell-selected-boxs #luckysheet-cell-selected").css({
                            "left": Store.luckysheet_select_save[i]["left_move"],
                            "width": Store.luckysheet_select_save[i]["width_move"],
                            "top": Store.luckysheet_select_save[i]["top_move"],
                            "height": Store.luckysheet_select_save[i]["height_move"],
                            "display": "block",
                            "border": "1px solid #0188fb"
                        })
                            .find(".luckysheet-cs-draghandle")
                            .css("display", "block")
                            .end()
                            .find(".luckysheet-cs-fillhandle")
                            .css("display", "none")
                            .end()
                            .find(".luckysheet-cs-touchhandle")
                            .css("display", "block");
                    }
                    else {
                        $("#luckysheet-cell-selected-boxs #luckysheet-cell-selected").css({
                            "left": Store.luckysheet_select_save[i]["left_move"],
                            "width": Store.luckysheet_select_save[i]["width_move"],
                            "top": Store.luckysheet_select_save[i]["top_move"],
                            "height": Store.luckysheet_select_save[i]["height_move"],
                            "display": "block",
                            "border": "1px solid #0188fb"
                        })
                            .find(".luckysheet-cs-draghandle")
                            .css("display", "block")
                            .end()
                            .find(".luckysheet-cs-fillhandle")
                            .css("display", "block")
                            .end()
                            .find(".luckysheet-cs-touchhandle")
                            .css("display", "none");
                        // if(luckysheetConfigsetting.activePanel == 'wire' && c2-c1 >= luckysheetConfigsetting.customColumnTitles.length-1) {
                        //     let width = Store.visibledatacolumn[7] - 2;
                        //     $("#luckysheet-cell-selected-boxs #luckysheet-cell-selected").css({
                        //         "left": Store.luckysheet_select_save[i]["left_move"],
                        //         "width": width,
                        //         "top": Store.luckysheet_select_save[i]["top_move"],
                        //         "height": Store.luckysheet_select_save[i]["height_move"],
                        //         "display": "block",
                        //         "border": border
                        //     })
                        //         .find(".luckysheet-cs-draghandle")
                        //         .css("display", "block")
                        //         .end()
                        //         .find(".luckysheet-cs-fillhandle")
                        //         .css("display", "block")
                        //         .end()
                        //         .find(".luckysheet-cs-touchhandle")
                        //         .css("display", "none");
                        //     let width2 = Store.visibledatacolumn[11] - Store.visibledatacolumn[7] - 1
                        //     let top = Store.visibledatarow[r1]
                        //     let height = Store.visibledatarow[r1+3] - Store.visibledatarow[r1+1] - 1
                        //     let width3 = col - Store.visibledatacolumn[11] - 1
                            
                        //     $("#luckysheet-cell-selected-boxs").append('<div class="luckysheet-cell-selected luckysheet-cell-selected-add" style="left: ' + (width + 1) + 'px; width: ' + width2 + 'px; top: ' + top + 'px; height: ' + height + 'px; border: ' + border + '; display: block;"></div>');
                        //     $("#luckysheet-cell-selected-boxs").append('<div class="luckysheet-cell-selected luckysheet-cell-selected-add" style="left: ' + (width + width2 + 2) + 'px; width: ' + width3 + 'px; top: ' + Store.luckysheet_select_save[i]["top_move"] + 'px; height: ' + Store.luckysheet_select_save[i]["height_move"] + 'px; border: ' + border + '; display: block;"></div>');
                        // } else {
                        //     $("#luckysheet-cell-selected-boxs #luckysheet-cell-selected").css({
                        //         "left": Store.luckysheet_select_save[i]["left_move"],
                        //         "width": Store.luckysheet_select_save[i]["width_move"],
                        //         "top": Store.luckysheet_select_save[i]["top_move"],
                        //         "height": Store.luckysheet_select_save[i]["height_move"],
                        //         "display": "block",
                        //         "border": border
                        //     })
                        //         .find(".luckysheet-cs-draghandle")
                        //         .css("display", "block")
                        //         .end()
                        //         .find(".luckysheet-cs-fillhandle")
                        //         .css("display", "block")
                        //         .end()
                        //         .find(".luckysheet-cs-touchhandle")
                        //         .css("display", "none");

                        //     $("#luckysheet-cell-selected-boxs").removeClass("luckysheet-cell-selected-boxs-add");
                        // }
                    }
                }
                else {
                    $("#luckysheet-cell-selected-boxs #luckysheet-cell-selected").css({
                        "left": Store.luckysheet_select_save[i]["left_move"],
                        "width": Store.luckysheet_select_save[i]["width_move"],
                        "top": Store.luckysheet_select_save[i]["top_move"],
                        "height": Store.luckysheet_select_save[i]["height_move"],
                        "display": "block",
                        "border": "1px solid rgba(1, 136, 251, 0.15)"
                    })
                        .find(".luckysheet-cs-draghandle")
                        .css("display", "none")
                        .end()
                        .find(".luckysheet-cs-fillhandle")
                        .css("display", "none");
                }
            }
            else {
                $("#luckysheet-cell-selected-boxs").append('<div class="luckysheet-cell-selected" style="left: ' + Store.luckysheet_select_save[i]["left_move"] + 'px; width: ' + Store.luckysheet_select_save[i]["width_move"] + 'px; top: ' + Store.luckysheet_select_save[i]["top_move"] + 'px; height: ' + Store.luckysheet_select_save[i]["height_move"] + 'px; border: 1px solid rgba(1, 136, 251, 0.15); display: block;"></div>');
                // let width = Store.visibledatacolumn[7] - 2;
                // let width2 = Store.visibledatacolumn[11] - Store.visibledatacolumn[7] - 1
                // let top = Store.visibledatarow[r1]
                // let height = Store.visibledatarow[r1+3] - Store.visibledatarow[r1+1] - 1
                // let width3 = col - Store.visibledatacolumn[11] - 1
                
                // $("#luckysheet-cell-selected-boxs").append('<div class="luckysheet-cell-selected" style="left: ' + Store.luckysheet_select_save[i]["left_move"] + 'px; width: ' + width + 'px; top: ' + Store.luckysheet_select_save[i]["top_move"] + 'px; height: ' + Store.luckysheet_select_save[i]["height_move"] + 'px; border: ' + border + '; display: block;"></div>');
                // $("#luckysheet-cell-selected-boxs").append('<div class="luckysheet-cell-selected luckysheet-cell-selected-add" style="left: ' + (width + 1) + 'px; width: ' + width2 + 'px; top: ' + top + 'px; height: ' + height + 'px; border: ' + border + '; display: block;"></div>');
                // $("#luckysheet-cell-selected-boxs").append('<div class="luckysheet-cell-selected luckysheet-cell-selected-add" style="left: ' + (width + width2 + 2) + 'px; width: ' + width3 + 'px; top: ' + Store.luckysheet_select_save[i]["top_move"] + 'px; height: ' + Store.luckysheet_select_save[i]["height_move"] + 'px; border: ' + border + '; display: block;"></div>'); 
                }

            if (i == Store.luckysheet_select_save.length - 1) {
                //focus 取选区数组最后一个
                $("#luckysheet-cell-selected-focus").css({
                    "left": Store.luckysheet_select_save[i]["left"],
                    "width": Store.luckysheet_select_save[i]["width"],
                    "top": Store.luckysheet_select_save[i]["top"],
                    "height": Store.luckysheet_select_save[i]["height"],
                    "display": "block"
                });
                //行列数
                luckysheet_count_show(
                    Store.luckysheet_select_save[i]["left_move"],
                    Store.luckysheet_select_save[i]["top_move"],
                    Store.luckysheet_select_save[i]["width_move"],
                    Store.luckysheet_select_save[i]["height_move"],
                    [r1, r2],
                    [c1, c2]
                );
                //左上角选择区域框
                formula.fucntionboxshow(rf, cf);
                //focus单元格数据验证
                dataVerificationCtrl.cellFocus(rf, cf);
            }
        }

        //行列标题栏
        selectTitlesShow(Store.luckysheet_select_save, isRestore);

        //左上角范围显示
        selectHelpboxFill();

        //动态数组显示
        if (Store.luckysheet_select_save.length == 1 && Store.luckysheet_select_save[0].row[0] == Store.luckysheet_select_save[0].row[1] && Store.luckysheet_select_save[0].column[0] == Store.luckysheet_select_save[0].column[1]) {
            dynamicArrayHightShow(Store.luckysheet_select_save[0].row[0], Store.luckysheet_select_save[0].column[0]);
        }
    
        /* 刷新当前状态栏 */
        refreshMenuButtonFocus();
    }

    Store.luckysheetfile[getSheetIndex(Store.currentSheetIndex)].luckysheet_select_save = Store.luckysheet_select_save;
            // Hook function, change the range selection box, selectHightlightShowillbe triggered multiple times when mousemove is moused, and thhistoricalvalue is used here to throttle
        const luckysheet_select_save_previous = JSON.stringify(Store.luckysheet_select_save);

        if(Store.luckysheet_select_save_previous == null |Store.luckysheet_select_save_previous !== luckysheet_select_save_previous){
            method.createHookFunction('rangeSelect', Store.luckysheetfile[getSheetIndex(Store.currentSheetIndex)], Store.luckysheet_select_save);
        }
        
        Store.luckysheet_select_save_previous = luckysheet_select_save_previous;
}

function selectOperationShow(r, c) {
    let titleObj = luckysheetConfigsetting.customColumnTitles[c]
    let rowIndex = r
    let row = 0
    if(titleObj && titleObj.isMerge == 1) {
        if(r == 0) {
            rowIndex = 0
            row = Store.visibledatarow[rowIndex]
        } else {
            rowIndex = r % 2 == 0 ? r - 1 : r
            row = Store.visibledatarow[rowIndex + 1]
        }
    } else {
        rowIndex = r == 0 || r % 2 == 0 ? r : r - 1
        row = Store.visibledatarow[rowIndex + 1]
    }
    console.log('实际行', rowIndex, '传入行',  r)
    let row_pre = rowIndex - 1 == -1 ? 0 : Store.visibledatarow[rowIndex - 1];
    let col = Store.visibledatacolumn[c],
        col_pre = c - 1 == -1 ? 0 : Store.visibledatacolumn[c - 1];
    $("#luckysheet-cell-operation-box").css({
        "left": col_pre,
        "width": col - col_pre - 1,
        "top": row_pre,
        "height": row - row_pre - 1,
        "display": "block"
    })

}

//选区标题栏
function selectTitlesShow(rangeArr, isRestore = false) {
    let s = $.extend(true, [], rangeArr);

    let rowTitleMap = {}, columnTitleMap = {};
    for (let i = 0; i < s.length; i++) {
        let r1 = s[i]["row"][0], r2 = s[i]["row"][1], c1 = s[i]["column"][0], c2 = s[i]["column"][1];

        // if(isRestore){
        //     let margeset = menuButton.mergeborer(Store.flowdata, r1, c1);
        //     if(!!margeset){
        //         r1 = margeset.row[2];
        //         r2 = margeset.row[3];

        //         c1 = margeset.column[2];
        //         c2 = margeset.column[3];
        //     }
        // }

        //行、列标题栏
        rowTitleMap = selectTitlesMap(rowTitleMap, r1, r2);
        columnTitleMap = selectTitlesMap(columnTitleMap, c1, c2);
    }

    //行标题
    $("#luckysheet-rows-h-selected").empty();

    let rowTitleRange = selectTitlesRange(rowTitleMap);
    for (let i = 0; i < rowTitleRange.length; i++) {
        let r1 = rowTitleRange[i][0], r2 = rowTitleRange[i][rowTitleRange[i].length - 1];
        let row = rowLocationByIndex(r2)[1], row_pre = rowLocationByIndex(r1)[0];

        $("#luckysheet-rows-h-selected").append('<div class="luckysheet-rows-h-selected" style="top: ' + row_pre + 'px; height: ' + (row - row_pre - 1) + 'px; display: block; background-color: rgba(76, 76, 76, 0.1);"></div>');
    }

    //列标题
    $("#luckysheet-cols-h-selected").empty();

    let columnTitleRange = selectTitlesRange(columnTitleMap);
    for (let j = 0; j < columnTitleRange.length; j++) {
        let c1 = columnTitleRange[j][0], c2 = columnTitleRange[j][columnTitleRange[j].length - 1];
        let col = colLocationByIndex(c2)[1], col_pre = colLocationByIndex(c1)[0];

        $("#luckysheet-cols-h-selected").append('<div class="luckysheet-cols-h-selected" style="left: ' + col_pre + 'px; width: ' + (col - col_pre - 1) + 'px; display: block; background-color: rgba(76, 76, 76, 0.1);"></div>');

    }
}
function selectTitlesMap(rangeMap, range1, range2) {
    let map = $.extend(true, {}, rangeMap);

    for (let i = range1; i <= range2; i++) {
        if (i in map) {
            continue;
        }

        map[i] = 0;
    }

    return map;
}
function selectTitlesRange(map) {
    let mapArr = [];

    for (let i in map) {
        mapArr.push(i);
    }

    mapArr.sort(function (a, b) { return a - b; });

    let rangeArr = [];
    let item = [];

    if (mapArr.length > 1) {
        for (let j = 1; j < mapArr.length; j++) {
            if (mapArr[j] - mapArr[j - 1] == 1) {
                item.push(mapArr[j - 1]);

                if (j == mapArr.length - 1) {
                    item.push(mapArr[j]);
                    rangeArr.push(item);
                }
            }
            else {
                if (j == 1) {
                    if (j == mapArr.length - 1) {
                        item.push(mapArr[j - 1]);
                        rangeArr.push(item);
                        rangeArr.push([mapArr[j]]);
                    }
                    else {
                        rangeArr.push(mapArr[0]);
                    }
                }
                else if (j == mapArr.length - 1) {
                    item.push(mapArr[j - 1]);
                    rangeArr.push(item);
                    rangeArr.push([mapArr[j]]);
                }
                else {
                    item.push(mapArr[j - 1]);
                    rangeArr.push(item);
                    item = [];
                }
            }
        }
    }
    else {
        rangeArr.push([mapArr[0]]);
    }

    return rangeArr;
}

//选区是否重叠
function selectIsOverlap(range) {
    if (range == null) {
        range = Store.luckysheet_select_save;
    }
    range = JSON.parse(JSON.stringify(range));

    let overlap = false;
    let map = {};

    for (let s = 0; s < range.length; s++) {
        let str_r = range[s].row[0],
            end_r = range[s].row[1];
        let str_c = range[s].column[0],
            end_c = range[s].column[1];

        for (let r = str_r; r <= end_r; r++) {
            for (let c = str_c; c <= end_c; c++) {
                if ((r + "_" + c) in map) {
                    overlap = true;
                    break;
                }
                else {
                    map[r + "_" + c] = 0;
                }
            }
        }
    }

    return overlap;
}
// 协同提示框
function collaborativeEditBox() {
    let all_width = Store.visibledatacolumn;//当前操作页的所有列距离左边的距离
    let all_height = Store.visibledatarow;//当前操作页的所有列距离顶部的距离

    Store.cooperativeEdit.changeCollaborationSize.forEach(value => {
        if (value.i == Store.currentSheetIndex) {
            let count_col = value.v.column;//系统提示框所在的列范围
            let change_width = all_width[count_col[0]] -1 //提示框所在列号为0时要改变的宽
            if(value.v.column[0] !== 0)  {
                //用提示框右边框到图表最左的距离减去左边框到图表左边距离再减去边框值
                change_width = all_width[count_col[1]] - all_width[count_col[0] - 1] - (count_col[1] - count_col[0] + 1)
            }
            let count_row = value.v.row;//系统提示框所在的行范围
            let change_height = all_height[count_row[0]] -1
            if(value.v.row[0] !== 0){
                change_height = all_height[count_row[1]] - all_height[count_row[0] - 1] - (count_row[1] - count_row[0] + 1)
            }
            let range = Store.cooperativeEdit.merge_range //获取单元格合并后的数据
            let change_left = all_width[value.v.column[0] - 1] - 1 //提示框离图表最左边的距离
            let change_top = all_height[value.v.row[0] - 1] - 1 //提示框离图表最右边的距离
            if (Store.config.columnlen !== null) {
                //当改变宽的列不在提示框范围内时，将改变列的初始位置改为在提示框范围内
                for (let k in Store.config.columnlen) {
                    if (value.v.column[0] <= k && k <= value.v.column[1]) {
                        Store.luckysheet_cols_change_size_start[1] = k - 0
                        break
                    }
                }
            }
            if (Store.config.rowlen !== null) {
                for (let k in Store.config.rowlen) {
                    if (value.v.row[0] <= k && k <= value.v.row[1]) {
                        Store.luckysheet_rows_change_size_start[1] = k - 0
                        break
                    }
                }
            }
            // 改变列宽的位置在提示框范围内
            let flag_width = value.v.column[0] <= Store.luckysheet_cols_change_size_start[1] && Store.luckysheet_cols_change_size_start[1] <= value.v.column[1]
            if (flag_width) {
                if (Store.luckysheet_cols_change_size_start[1] == 0) {
                    change_width = all_width[0] - 1
                } else {
                    // 不在提示框范围内
                    let counts = value.v.column;
                    change_width = all_width[counts[1]] - all_width[counts[0] - 1] - (counts[1] - counts[0] + 1)
                }
            }
            let flag_height = value.v.row[0] <= Store.luckysheet_rows_change_size_start[1] && Store.luckysheet_rows_change_size_start[1] <= value.v.row[1]
            if (flag_height) {
                if (Store.luckysheet_rows_change_size_start[1] == 0) {
                    change_height = all_height[0] - 1
                } else {
                    let counts = value.v.row;
                    change_height = all_height[counts[1]] - all_height[counts[0] - 1] - (counts[1] - counts[0] + 1)
                }
            }
            //合并单元格时执行
            if (Object.keys(range).length > 0 ) {
                let flag_sure_merge = false
                if(range.v.length > 1) {
                    flag_sure_merge = range.v[1][0] == null || Object.keys(range.v[1][0]).length > 0
                }
                if(range.v[0].length > 1) {
                    flag_sure_merge = range.v[0][1] == null || Object.keys(range.v[0][1]).length > 0
                }
                if(flag_sure_merge) {
                    // 合并成一个时执行
                    let flag_merge_width = range.column[0] <= value.v.column[0] && range.column[1] >= value.v.column[1];
                    change_left = all_width[range.column[0] - 1] - 1
                    change_top = all_height[range.row[0] - 1] - 1
                    change_width = all_width[range.column[1]] - 1
                    change_height = all_height[range.row[1]] - 1
                    if (flag_merge_width) {
                        if (range.column[0] !== 0) {
                            let counts = range.column;
                            change_width = all_width[counts[1]] - all_width[counts[0] - 1] - (counts[1] - counts[0] + 1)
                        } else {
                            change_left = 0
                        }
                        value.v.column = range.column
                    }
                    let flag_merge_height = range.row[0] <= value.v.row[0] && range.row[1] >= value.v.row[1];
                    if (flag_merge_height) {
                        if (range.row[0] !== 0) {
                            let counts = range.row;
                            change_height = all_height[counts[1]] - all_height[counts[0] - 1] - (counts[1] - counts[0] + 1)
                        } else {
                            change_top = 0
                        }
                        value.v.row = range.row
                    }
                } else {
                    // 合并取消变成多个单元格时执行
                    change_width = all_width[count_col[0]] - all_width[count_col[0] - 1] - 1
                    if(count_col[0] === 0) {
                        change_width = all_width[count_col[0]] - 1
                    }
                    change_height = all_height[count_row[0]] - all_height[count_row[0] - 1] - 1
                    if(count_row[0] === 0) {
                        change_height = all_height[count_row[0]] - 1
                    }
                }
            }
            $("#luckysheet-multipleRange-show-" + value.id).css({ "height": change_height, "width": change_width, "top": change_top + 'px', "left": change_left + 'px' })
            let change_bottom = $("#luckysheet-multipleRange-show-" + value.id)[0].offsetHeight - 1
            $("#luckysheet-multipleRange-show-" + value.id + ">.username").css({ "bottom": change_bottom + 'px' })
        }
    })
}
//复制选区虚线框
function selectionCopyShow(range) {
    $("#luckysheet-selection-copy").empty();

    if (range == null) {
        range = Store.luckysheet_selection_range;
    }
    range = JSON.parse(JSON.stringify(range));
    let currentSheetIndex = luckysheet.getActiveSheetIndex()
    let rowL = 0
    let colL = 0
    let dataSource = ''
    // if($('#luckysheet-dataVerificationRange-dialog-confirm')){
    //   dataSource = $('#luckysheet-dataVerificationRange-dialog-confirm').attr("data-source") || ''
    //   rowL = luckysheet.getAllSheets()[currentSheetIndex].data.length - 1
    //   colL = luckysheet.getAllSheets()[currentSheetIndex].data[0].length - 1
    // }
    if($("#luckysheet-print-rangeItem-dialog").is(":visible")){
      dataSource = $('#luckysheet-print-rangeItem-dialog .luckysheet-print-rangeItem-content').attr("data-source") || ''
      rowL = luckysheet.getAllSheets()[currentSheetIndex].data.length - 1
      colL = luckysheet.getAllSheets()[currentSheetIndex].data[0].length - 1
    }
    if (range.length > 0) {
        for (let s = 0; s < range.length; s++) {
            let r1 = range[s].row[0], r2 = range[s].row[1];
            let c1 = range[s].column[0], c2 = range[s].column[1];
            if(dataSource == 3){
              r1 = 0, r2 = rowL;
            }else if(dataSource == 2){
              c1 = 0, c2 = colL;
            }

            let row = Store.visibledatarow[r2],
                row_pre = r1 - 1 == -1 ? 0 : Store.visibledatarow[r1 - 1];
            let col = Store.visibledatacolumn[c2],
                col_pre = c1 - 1 == -1 ? 0 : Store.visibledatacolumn[c1 - 1];

            let copyDomHtml = '<div class="luckysheet-selection-copy" style="display: block; left: ' + col_pre + 'px; width: ' + (col - col_pre - 1) + 'px; top: ' + row_pre + 'px; height: ' + (row - row_pre - 1) + 'px;">' +
                '<div class="luckysheet-selection-copy-top luckysheet-copy"></div>' +
                '<div class="luckysheet-selection-copy-right luckysheet-copy"></div>' +
                '<div class="luckysheet-selection-copy-bottom luckysheet-copy"></div>' +
                '<div class="luckysheet-selection-copy-left luckysheet-copy"></div>' +
                '<div class="luckysheet-selection-copy-hc"></div>' +
                '</div>';
            $("#luckysheet-selection-copy").append(copyDomHtml);
        }
    }
}

//选区行列数显示
function luckysheet_count_show(left, top, width, height, rowseleted, columnseleted) {
    let rowl = rowseleted[1] - rowseleted[0] + 1,
        coll = columnseleted[1] - columnseleted[0] + 1;
    let drawWidth = Store.luckysheetTableContentHW[0],
        drawHeight = Store.luckysheetTableContentHW[1];
    let scrollWidth = $("#luckysheet-cell-main").scrollLeft(),
        scrollHeight = $("#luckysheet-cell-main").scrollTop();

    const _locale = locale();
    const locale_info = _locale.info;

    if (rowl >= 4) {
        let leftv = left - 25;
        if (leftv < 0) {
            leftv = left + 5;
        }

        if (leftv < scrollWidth) {
            leftv = scrollWidth + 10;
        }

        let topv = top + height / 2;
        if (height > drawHeight) {
            topv = scrollHeight + drawHeight / 2;
        }

        $("#luckysheet-row-count-show").css({ "left": leftv, "top": topv, "display": "block", "width": "11px" }).html("<div>" + rowl.toString().split("").join("</div><div>") + "</div><div>" + locale_info.row + "</div>");
    }
    else {
        $("#luckysheet-row-count-show").hide();
    }

    if (coll >= 4) {
        let topv = top - 25;
        if (topv < 0) {
            topv = top + 5;
        }

        if (topv < scrollHeight) {
            topv = scrollHeight + 10;
        }

        let leftv = left + width / 2;
        if (width > drawWidth) {
            leftv = scrollWidth + drawWidth / 2;
        }

        $("#luckysheet-column-count-show").css({ "left": leftv, "top": topv, "display": "block" }).text(coll + locale_info.column);
    }
    else {
        $("#luckysheet-column-count-show").hide();
    }
}

function selectHelpboxFill() {
    let range = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1];
    let rf = range["row_focus"], cf = range["column_focus"];
    if (Store.config["merge"] != null && (rf + "_" + cf) in Store.config["merge"]) {
        $("#luckysheet-helpbox-cell").text(getRangetxt(Store.currentSheetIndex, {
            column: [cf, cf],
            row: [rf, rf],
        }));
    }
    else {
        $("#luckysheet-helpbox-cell").text(getRangetxt(Store.currentSheetIndex, range));
    }

}

// 填充报错信息
// 默认合并两个数组
function fullErrorRow(arr = [], type = 'add') {
    if(type == 'add') {
        let list = Store.errorRow
        // 1. 合并两个数组（先放一起再说）
        const combined = [...list, ...arr];

        const rowMap = new Map();
        combined.forEach(item => {
        const { row, col = [], ...rest } = item; // 解构 row、col，其余字段（如 msg）放 rest 里
        if (!rowMap.has(row)) {
            // 新 row：直接存入，col 先去重（避免原数组内重复）
            const uniqueCols = [...new Set(col.map(c => c.column))].map(colVal => ({ column: colVal }));
            rowMap.set(row, { row, col: uniqueCols, ...rest });
        } else {
            // 已有该 row：合并 col 并去重，覆盖 rest 字段（如 msg 以最后出现的为准）
            const existingItem = rowMap.get(row);
            // 提取已有 column + 新 column，去重后重组
            const allColumns = [...existingItem.col.map(c => c.column), ...col.map(c => c.column)];
            const uniqueCols = [...new Set(allColumns)].map(colVal => ({ column: colVal }));
            // 合并 rest 字段（后出现的覆盖前一个，比如 arr2 的 row1 没有 msg，就保留 arr1 的 msg）
            rowMap.set(row, { ...existingItem, ...rest, col: uniqueCols });
        }
        });

        // 3. 转成最终数组（按 row 升序排列，可选）
        mergedResult = Array.from(rowMap.values()).sort((a, b) => a.row - b.row);
    } else {
        mergedResult = arr
    }
    
    // $("#luckysheet-row-error-boxs").show();
    // $("#luckysheet-row-error-h-boxs").show();
    // let childHtml = ''
    // let childHtmlH = ''
    // mergedResult.forEach(el => {
    // if((el.msg && el.msg != '数据有误') || (el.col && el.col.length && el.msg == '数据有误')) {
    //     let row_f = Store.visibledatarow[el.row]
    //     let row_f2 = Store.visibledatarow[el.row + 1]
    //     let row_pre_f = el.row - 1 == -1 ? 0 : Store.visibledatarow[el.row - 1];
    //     childHtml += `<div class="row-item" data-row="${el.row}" style="top: ${row_pre_f - 1}px; height: ${row_f2 - row_pre_f - 2}px"></div>`
    //     childHtmlH += `<div class="row-item" data-row="${el.row}" style="top: ${row_pre_f + 1}px; height: ${row_f2 - row_pre_f - 1}px"><i class="iconfont icon-sheet-error" title="${el.msg||'无'}"></i></div>`
    // }
    // })
    Store.errorRow = mergedResult
    drawError()
    // $("#luckysheet-row-error-boxs")
    // .html(childHtml)
    // $("#luckysheet-row-error-h-boxs")
    // .html(childHtmlH)
}

function clearErrorRow(list) {
    if(!list || !list.length) return
    list.forEach(el => {
        let index = Store.errorRow.findIndex(e => e.row == el)
        if(index > -1) {
            Store.errorRow.splice(index, 1)
            $('#luckysheet-row-error-boxs').find(`[data-row="${el}"]`).remove();
            $('#luckysheet-row-error-h-boxs').find(`[data-row="${el}"]`).remove();
        }
    })
}

// 报错小三角提示
async function drawError() {
    if(Store.errorRow && Store.errorRow.length) {
        
        let luckysheetTableContent = null
        let luckysheetTableContentDefault = $("#luckysheetTableContent")
            .get(0)
            .getContext("2d");
        let luckysheetTableContentFrozen = $("#freezen_v")
            .get(0)
            .getContext("2d");
        let scrollWidth = $("#luckysheet-cell-main").scrollLeft();
        let scrollHeight = $("#luckysheet-cell-main").scrollTop();
        let dv_w = 5 * Store.zoomRatio,
            dv_h = 5 * Store.zoomRatio; //红色小三角宽高
        let clearList = []
        Store.errorRow.forEach(item => {
            let r = item.row
            if(item.col && item.col.length) {
                item.col.forEach(el => {
                    let c = el.column
                    // 隐藏列不校验
                    if(Store.config.colhidden && Store.config.colhidden[c] == 0) {
                        return
                    }
                    let start_r;
                    if (r == 0) {
                        start_r = -scrollHeight;
                    } else {
                        start_r = Store.visibledatarow[r - 1] - scrollHeight;
                    }
                    let start_c;
                    if (c == 0) {
                        start_c = -scrollWidth;
                    } else {
                        start_c = Store.visibledatacolumn[c - 1] - scrollWidth;
                    }
                    // 固定区域和非固定区域使用不同的canvas
                    let offsetLeft = 0,
                        offsetTop = 0;
                    // if(c < 14) {
                    //     luckysheetTableContent = luckysheetTableContentFrozen
                    // } else {
                        offsetLeft = Store.rowHeaderWidth
                        offsetTop = Store.columnHeaderHeight;
                        luckysheetTableContent = luckysheetTableContentDefault
                    // }
                    if(start_r < 0) {
                        return
                    }
                    luckysheetTableContent.beginPath();
                    luckysheetTableContent.moveTo(start_c + offsetLeft + 1, start_r + offsetTop + 1);
                    luckysheetTableContent.lineTo(start_c + offsetLeft + dv_w + 1, start_r + offsetTop + 1);
                    luckysheetTableContent.lineTo(start_c + offsetLeft + 1, start_r + offsetTop + dv_h + 1);
                    luckysheetTableContent.fillStyle = "#FC6666";
                    luckysheetTableContent.fill();
                    luckysheetTableContent.closePath();
                    // luckysheetTableContent.fillText(`${start_c + offsetLeft}+${start_r + offsetTop}`, start_c + offsetLeft, start_r + offsetTop)
                })
            } else if(!item.msg || item.msg == '数据有误') {
                clearList.push(r)
            }
        })
        if(clearList.length) {
            // 清除报错信息
            clearErrorRow(clearList)
        }
    } else {
        $('#luckysheet-row-error-boxs').html('');
        $('#luckysheet-row-error-h-boxs').html('');
    }
}
// async function drawError(luckysheetTableContent, rowIndex, colIndex) {
//     if(Store.errorRow && Store.errorRow.length) {
//         let row = Store.errorRow.find(item => item.row == rowIndex)
//         if(row && row.col && row.col.findIndex(el => el.column == colIndex) > -1) {
            
//         }
//     }
// }

// 单元格提示信息
function showMessage (r, c, curCell0, text) {
    // 默认合并两行
    let fIndex = luckysheetConfigsetting.mergeCol.findIndex(v => v.index == c)
    
    let rowConfigIndex = luckysheetConfigsetting.customColumnTitles.findIndex(item => item.fieldName == 'rowConfig')
    let rodTowerNoIndex = luckysheetConfigsetting.customColumnTitles.findIndex(item => item.fieldName == 'rodTowerNo')
    if(r != 0 || fIndex < 0) {
        r += 1;
    }
    let row = Store.visibledatarow[r],
        col_pre = c == 0 ? 0 : Store.visibledatacolumn[c - 1];
    
    // let trowTypeCell = Store.flowdata[r][4]
    let rowVal = Store.flowdata[r]
    let rowPreVal = r == 0 ? null : Store.flowdata[r - 1]

    let failureText = ''
    if(text) {
        failureText = text
    }
    //  else if(c == 1 && curCell0 && curCell0.isInitial && !curCell0.relatedId &&
    //     (!rowVal[1] || luckysheetConfigsetting.isEmptyString(rowVal[1].v) )
    // ) {
    //     failureText = '请填写分支起始杆信息！'
    // } 
    // else if(c == rodTowerNoIndex && curCell0 && curCell0.isInitial && !curCell0.relatedId){
    else if(c == rodTowerNoIndex && curCell0 && curCell0.isInitial){
        failureText = '分支线路电源点'
    } else if ( c == 10 &&
        (
            (rowPreVal && rowPreVal[rowConfigIndex] && rowPreVal[rowConfigIndex].isInitial && rowPreVal[rowConfigIndex].relatedId) || // 关联情况
            (rowVal && rowVal[rowConfigIndex] && rowVal[rowConfigIndex].isInitial && !rowVal[rowConfigIndex].relatedId) // 新增情况
        )
    ) {
        // 仅需要分支杆的第一根杆需要提示
        failureText = '请填写此杆塔主线路最大截面！'
    } else if (c == 12 &&
        rowVal[4] &&
        rowVal[4].v == '宽基塔' &&
        ((!rowVal[30] || luckysheetConfigsetting.isEmptyString(rowVal[30].v)) ||
        (!rowVal[31] || luckysheetConfigsetting.isEmptyString(rowVal[31].v)) ||
        (!rowVal[32] || luckysheetConfigsetting.isEmptyString(rowVal[32].v)) ||
        (!rowVal[33] || luckysheetConfigsetting.isEmptyString(rowVal[33].v)))
    ) {
        failureText = '请选择宽基塔塔腿！'
    }
    if(failureText) {
        $("#luckysheet-dataVerification-showHintBox").html(failureText).show().css({
            'left': col_pre,
            'top': row
        });
    }
}

/**
 *  判断是否可以可以编辑
 * r 行 c列
 * type 操作类型 默认是编辑
 * type=del 删除情况下 分支起始杆可以删除
 * */
// 
// 操作类型 默认是编辑
function isEditRow(rIndex, c, type) {
    let r = Number(rIndex) % 2 == 0 ? rIndex : rIndex - 1
    let rowConfigIndex = luckysheetConfigsetting.customColumnTitles.findIndex(item => item.fieldName == 'rowConfig')
    // console.log('isEditRow', rIndex, r, c, type)
    // 禁止编辑，当前关联分支线路电源点
    let curRow = luckysheet.getcellvalue(r)
    let curCell0 = curRow ? curRow[rowConfigIndex] : null

    if(curCell0 && curCell0.isInitial && curCell0.relatedId && type != 'del' && c == 1) {
        showMessage(rIndex, c, curCell0, '分支线路电源点')
        return false
    }
    // 禁止编辑，如果下一行是分支线路电源点 整行不能编辑(插入到最后一行type='auto)
    let nextRow = luckysheet.getcellvalue(r + 2)
    let nextCell0 = nextRow ? nextRow[rowConfigIndex] : ''
    if(nextCell0 && nextCell0.isInitial && nextCell0.type == 'auto' ) {
        showMessage(rIndex, c, curCell0, '主线路分支线路最后一行禁止编辑！')
        return false
    }

    // 禁止编辑，如果上一行是分支线路电源点 整行不能编辑(插入到狗一行后面type='manual')
    let perRow = luckysheet.getcellvalue(r - 2)
    let perCell0 = perRow ? perRow[rowConfigIndex] : ''
    if(perCell0 && perCell0.isInitial && perCell0.type == 'manual' ) {
        showMessage(rIndex, c, curCell0, '主线路分支线路后一行禁止编辑！')
        return false
    }

    if(type == 'del' && curCell0 && curCell0.id) {
        let d = luckysheet.getcellvalue()
        let hasRelated = d.some(v => v[rowConfigIndex] && v[rowConfigIndex].isInitial && v[rowConfigIndex].relatedId == curCell0.id)
        if(hasRelated) {
            showMessage(rIndex, c, curCell0, '改杆塔已关联了分支线路，请先解除关联后操作！')
            return false
        }
    }

    let fIndex = luckysheetConfigsetting.mergeCol.findIndex(v => v.index == c)
    if(rIndex == 0 && fIndex > -1) {
        showMessage(rIndex, c, curCell0, '禁止编辑！')
        return false
    }

    let directBurialIndex = luckysheetConfigsetting.customColumnTitles.findIndex(v => v.fieldName == 'directBurial')
    if(c == directBurialIndex) {
        showMessage(rIndex, c, curCell0, '根据档距或总长自动填入！')
        return false
    }

    let sgzsbyqVoltageLevelIndex = luckysheetConfigsetting.customColumnTitles.findIndex(v => v.fieldName == 'sgzsbyqVoltageLevel')
    let dgzsbyqVoltageLevelIndex = luckysheetConfigsetting.customColumnTitles.findIndex(v => v.fieldName == 'dgzsbyqVoltageLevel')
    if((c == sgzsbyqVoltageLevelIndex || c == dgzsbyqVoltageLevelIndex)) {
        showMessage(rIndex, c, curCell0, '禁止编辑！')
        return false
    }

    // if(c == 13 && curRow[3] && curRow[3].v == '新建') {
    //     if((!curRow[13] || !curRow[13].v)) {
    //         showMessage(r, c, curCell0, '杆塔状态为“新建”，根据杆型代号自动填入！')
    //     }
    //     return false
    // }

    // 当是否配置塔腿都等于否时，在宽基塔塔腿中宽基塔A腿高、宽基塔B腿高、宽基塔C腿高、宽基塔D腿高填入空且不能修改
    const customColumnTitles = luckysheetConfigsetting.customColumnTitles;
    let legAIndex = customColumnTitles.findIndex(v => v.fieldName == 'legA')
    let legBIndex = customColumnTitles.findIndex(v => v.fieldName == 'legB')
    let legCIndex = customColumnTitles.findIndex(v => v.fieldName == 'legC')
    let legDIndex = customColumnTitles.findIndex(v => v.fieldName == 'legD')
    let {
        bigObj1 = {},
    } = getRowValue(r)
    let rodTypeModuleIdObj = bigObj1['rodTypeModuleId'] ? bigObj1['rodTypeModuleId'] : {}
    let isConfigLeg = rodTypeModuleIdObj && rodTypeModuleIdObj.isConfigLeg ? rodTypeModuleIdObj.isConfigLeg : ''
    if((c == legAIndex || c == legBIndex || c == legCIndex || c == legDIndex) && isConfigLeg == '否') {
        showMessage(rIndex, c, curCell0, '禁止编辑！')
        return false
    }

    return true
}

// 修改分支线路，之分支杆塔编号也要跟着改
function editRelateCell () {
    let rowConfigIndex = luckysheetConfigsetting.customColumnTitles.findIndex(item => item.fieldName == 'rowConfig')
    let rodTowerNoIndex = luckysheetConfigsetting.customColumnTitles.findIndex(item => item.fieldName == 'rodTowerNo')
    // let jfredo = JSON.parse(JSON.stringify(Store.jfredo))
    let list = Store.flowdata
    Store.editRow && Store.editRow.forEach(el => {
        let id = list[el] && list[el][rowConfigIndex] && list[el][rowConfigIndex].id
        let code = list[el] && list[el][rodTowerNoIndex] && list[el][rodTowerNoIndex].v
        if( id && code ) {
            list.forEach((e, index) => {
                if( e[rowConfigIndex] && e[rowConfigIndex].id && e[rowConfigIndex].relatedId && e[rowConfigIndex].relatedId == id) {
                    let cell = e[rodTowerNoIndex] || {v: '', m: ''}
                    if(cell.v != code) {
                        cell.v = code
                        cell.m = code
                        luckysheet.setCellValue(index, 1, cell, { upadtejfredo: false})
                    }
                }
            })
        }
    })
    
    // Store.jfredo = jfredo
}

// 自动填充杆头编号
async function fullCellTower(r) {
    let row = Store.flowdata[r]
    let rowVal = {}
    let rodTypeC = 0
    let headC = 0
    luckysheetConfigsetting.customColumnTitles.forEach((v, cIndex) => {
        if(row[cIndex]) {
            let cell = row[cIndex]
            rowVal[v.value] = !luckysheetConfigsetting.isEmptyString(cell.v) ? cell.saveVal || cell.v : ''
        }
        if(v.value == 'rodTypeModuleId') {
            rodTypeC = cIndex
        }
        if(v.value == 'rodHeadModuleId') {
            headC = cIndex
        }
    })
    // let jfredo = JSON.parse(JSON.stringify(Store.jfredo))
    // 自动填充杆头
    let lastRodType = Store.fullCellTower[rodTypeC]
    let nowRodType = {}
    let nowHead = row[headC] || {}
    if(row[rodTypeC] && !luckysheetConfigsetting.isEmptyString(row[rodTypeC].v) && !luckysheetConfigsetting.isEmptyString(row[rodTypeC].saveVal)) {
        nowRodType = {
            v: row[rodTypeC].v,
            saveVal: row[rodTypeC].saveVal,
            saveObj: row[rodTypeC].saveObj,
        }
        if(JSON.stringify(lastRodType) != JSON.stringify(nowRodType) && rowVal.moduleState == '新建') {
            Store.fullCellTower[rodTypeC] = $.extend(true, {}, nowRodType);
            let item = dataVerificationCtrl.dataVerification[headC];
            let obj = await dataVerificationCtrl.getDropdownList(item, r, headC)
            if(
                Object.prototype.toString.call(obj) === '[object Object]' &&
                JSON.stringify(obj) != '{}'
            ) {
                let keys = Object.keys(obj)
                if(keys.length === 1) {
                    let val = keys[0]
                    let saveObj = obj[val] && obj[val].length === 1 ? obj[val][0] : {}
                    nowHead = Object.assign(nowHead, {
                        v: val,
                        m: val,
                        saveVal: saveObj.moduleId,
                        saveObj: saveObj,
                    })
                } else {
                    nowHead = null
                }
            } else {
                nowHead = null
            }
            luckysheet.setCellValue(r, headC, nowHead, { upadtejfredo: false})
        }
    } else {
       Store.fullCellTower[rodTypeC] = null
       if(nowHead && !luckysheetConfigsetting.isEmptyString(nowHead.v)) {
            luckysheet.setCellValue(r, headC, null, { upadtejfredo: false})
       }
    }
    // if(rowVal.moduleState == '新建') {
    //     if(JSON.stringify(lastHead))
    // }
    // let cell = null
    // if(rowVal.moduleState == '新建' ) {
    //     console.log('重写杆头')
    //     if(
    //         rowVal.moduleState == '新建' &&
    //         rowVal.isBase && JSON.stringify(rowVal.isBase) &&
    //         rowVal.rodTowerMaterial && JSON.stringify(rowVal.rodTowerMaterial) &&
    //         rowVal.isLowPressure && JSON.stringify(rowVal.isLowPressure) &&
    //         rowVal.rodTowerTypeCode && JSON.stringify(rowVal.rodTowerTypeCode) &&
    //         rowVal.wireModuleState && JSON.stringify(rowVal.wireModuleState) &&
    //         rowVal.writeType && JSON.stringify(rowVal.writeType) &&
    //         rowVal.crossSectionArea && JSON.stringify(rowVal.crossSectionArea) &&
    //         rowVal.wireSpan && JSON.stringify(rowVal.wireSpan) &&
    //         rowVal.rodTypeModuleId && JSON.stringify(rowVal.rodTypeModuleId)
    //     ) {
    //         // 判断这次参数和上次不同 才发出请求
    //         let towerObj = {
    //             moduleState: rowVal.moduleState,
    //             moduleState: rowVal.isBase,
    //             moduleState: rowVal.rodTowerMaterial,
    //             moduleState: rowVal.isLowPressure,
    //             moduleState: rowVal.rodTowerTypeCode,
    //             moduleState: rowVal.wireModuleState,
    //             moduleState: rowVal.writeType,
    //             moduleState: rowVal.crossSectionArea,
    //             moduleState: rowVal.wireSpan,
    //             moduleState: rowVal.rodTypeModuleId,
    //         }
    //         console.log(JSON.stringify(Store.fullCellTower) !== JSON.stringify(towerObj))
    //         if(JSON.stringify(Store.fullCellTower) !== JSON.stringify(towerObj)) {
    //             Store.fullCellTower = towerObj
    //             let item = dataVerificationCtrl.dataVerification[c];

    //             let obj = await dataVerificationCtrl.getDropdownList(item, r, c)
    //             if(
    //                 Object.prototype.toString.call(obj) === '[object Object]' &&
    //                 JSON.stringify(obj) != '{}'
    //             ) {
    //                 let keys = Object.keys(obj)
    //                 if(keys.length === 1) {
                        
    //                     let val = keys[0]
    //                     let saveObj = obj[val] && obj[val].length === 1 ? obj[val][0] : {}
    //                     cell = {
    //                         v: val,
    //                         m: val,
    //                         saveVal: val,
    //                         saveObj: saveObj,
    //                     }
    //                 }
    //             }
    //         } else {
    //            return
    //         }
    //     }
    // } else {
    //     if(rowVal.moduleState === Store.fullCellTower.moduleState) {
    //         return
    //     } 
    //     Store.fullCellTower = {moduleState: rowVal.moduleState}
    // }
    // luckysheet.setCellValue(r, c, cell)

    // 宽基塔信息删掉时，宽基塔塔腿也一起删除
    if(rowVal.rodTowerMaterial != '宽基塔') {
        if(!luckysheetConfigsetting.isEmptyString(rowVal.legA)) {
            luckysheet.setCellValue(r, 30, null, { upadtejfredo: false})
        }
        if(!luckysheetConfigsetting.isEmptyString(rowVal.legB)) {
            luckysheet.setCellValue(r, 31, null, { upadtejfredo: false})
        }
        if(!luckysheetConfigsetting.isEmptyString(rowVal.legC)) {
            luckysheet.setCellValue(r, 32, null, { upadtejfredo: false})
        }
        if(!luckysheetConfigsetting.isEmptyString(rowVal.legD)) {
            luckysheet.setCellValue(r, 33, null, { upadtejfredo: false})
        }
    }
    // Store.jfredo = jfredo
}

// 填充造价-杆塔组立参数默认参数
function fillDefaultVal (row_index, d=Store.flowdata, isFill = true) {
    // 造价参数部分需要填充默认值
    const dataVerification = dataVerificationCtrl.dataVerification
    if(dataVerification) {
        for (const key in dataVerification) {
            if (!Object.hasOwn(dataVerification, key)) continue;
            const element = dataVerification[key];
            let titleObj = luckysheetConfigsetting.customColumnTitles[key]
            if(element && element.defaultVal && titleObj.optionType == '杆塔组立') {
                let row_index1 = row_index
                if(titleObj.isMerge == 1) {
                    row_index1 = row_index == 0 || row_index % 2 == 0 ? row_index + 1 : row_index
                } else {
                    row_index1 = row_index == 0 || row_index % 2 == 0 ? row_index : row_index - 1
                }
                let cell = d[row_index1][key]
                if((!cell || !cell.v || luckysheetConfigsetting.isEmptyString(cell.v)) && isFill) {
                    if (element.conditionMap && JSON.stringify(element.conditionMap) != '{}') {
                        let {
                            bigObj = {},
                            bigObj1 = {},
                            bigObj2 = {},
                            bigObj4 = {},
                            bigObj3 = {},
                        } = getRowValue(row_index1)

                        let conditionObj = null
                        let conditionMap = element.conditionMap
                        for (let index = 0; index < conditionMap.length; index++) {
                            const el = conditionMap[index];
                            let off = el.condition.every(v => {
                                let { val, key } = v
                                if(!val) {
                                    return !!bigObj[key]
                                } else {
                                    let result = val.split('#&#')
                                    let nowResult = ''
                                    if(bigObj[key] && !JSON.stringify(bigObj[key]).includes('#&#')) {
                                        nowResult = bigObj[key]
                                    } else if(bigObj2[key] && !JSON.stringify(bigObj2[key]).includes('#&#')) {
                                        nowResult = bigObj2[key]
                                    } else if(bigObj3[key] && !JSON.stringify(bigObj3[key]).includes('#&#')) {
                                        nowResult = bigObj3[key]
                                    }
                                    return result.includes(nowResult)
                                }
                            })
                            if (off) {
                                conditionObj = el
                                break
                            }
                        }
                        console.log('conditionObj', conditionObj);
                        if(conditionObj && conditionObj.defaultVal) {
                            cell = {
                                v: conditionObj.defaultVal,
                                m:conditionObj.defaultVal,
                                saveVal: conditionObj.defaultVal
                            }
                            if(element.fieldName == 'baseType' && !['单杆', '双杆', '侧担杆'].includes(bigObj.rodTowerMaterial)) {
                                cell = null
                            }
                            luckysheet.setCellValue(row_index1, key, cell, {upadtejfredo: false})
                        }
                    } else {
                        cell = {
                            v: element.defaultVal,
                            m:element.defaultVal,
                            saveVal: element.defaultVal
                        }
                        luckysheet.setCellValue(row_index1, key, cell, {upadtejfredo: false})
                    }
                } else if(cell && !luckysheetConfigsetting.isEmptyString(cell.v) && !isFill) {
                    luckysheet.setCellValue(row_index1, key, null, {upadtejfredo: false})
                } else if(cell && !luckysheetConfigsetting.isEmptyString(cell.v) && isFill) {
                    let { bigObj = {} } = getRowValue(row_index1)
                    // 特殊处理杆塔类型改了之后，基础类型需要清空
                    if(element.fieldName == 'baseType') {
                        if(!['单杆', '双杆', '侧担杆'].includes(bigObj.rodTowerMaterial)) {
                            luckysheet.setCellValue(row_index1, key, null, {upadtejfredo: false})
                        }
                    }
                    // 杆塔结构是钢管杆、窄基塔、宽基塔时，除了混凝土立杆方式不 默认，其他按单杆的默认规则去出默认值
                    if(element.fieldName == 'rodMethod') {
                        // 特殊处理杆方法 
                        if(!['单杆', '双杆', '侧担杆'].includes(bigObj.rodTowerMaterial)) {
                            luckysheet.setCellValue(row_index1, key, null, {upadtejfredo: false})
                        }
                    }
                }
            } 
        }
    }
}

// 获取合并行数据
// rowLength 总行数
// 返回merge对象
function getMerge(rowLength) {
    const mergeCol = luckysheetConfigsetting.mergeCol;
    const customColumnTitles = luckysheetConfigsetting.customColumnTitles;
    let merge = {}
    for (let i = 0; i < rowLength -1; i++) {
        customColumnTitles.forEach((el, j) => {
            if(i % 2 == 0) {
                if(el.optionType != 'hidden' && !mergeCol.find(item => item.fieldName === el.fieldName)) {
                    merge[`${i}_${j}`] = {
                        "r": i,
                        "c": j,
                        "rs": 2,
                        "cs": 1
                    }
                }
            } else if(mergeCol.find(item => item.fieldName === el.fieldName)) {
                merge[`${i}_${j}`] = {
                    "r": i,
                    "c": j,
                    "rs": 2,
                    "cs": 1
                }
            }
        })

    }
    return merge
}

/**
 * 将直埋, 电缆沟(隧)道, 排管内, 沿支架、墙面卡设, 沿桥架, 竖直通道, 电缆上杆或进、出设备柜，填写的长度累计起来
 * directBurial cableTrench pipeLaying support cableTray channel cableOnPole
 * 与该电缆档距或总长（m）比较
 * wireSpan
 * 如果长度不一致， 在备注提示电缆敷设长度与档距或总长（m）不一致，请复核(去掉)
 * layNote
 * 且为电缆情况下才需要校验 导线类型的 writeType.type = 2
 * bigObj1.writeType && bigObj1.writeType.type = 2
 * 直埋=档距或总长-电缆沟(隧)道-排管内-沿支架、墙面卡设- 沿桥架- 竖直通道-电缆上杆或进-出设备柜
 */
function checkLength(row_index, d=Store.flowdata) {
    // let paramsArr = ['directBurial', 'cableTrench', 'pipeLaying', 'support', 'cableTray', 'channel', 'cableOnPole', 'wireSpan']
    // let paramsIndex = []
    const customColumnTitles = luckysheetConfigsetting.customColumnTitles;
    // paramsArr.forEach(el => {
    //     let index = customColumnTitles.findIndex(item => item.fieldName === el)
    //     if(index > -1) {
    //        paramsIndex.push(index)
    //     }
    // })
    let {
        bigObj = {},
        bigObj1 = {},
    } = getRowValue(row_index)
    
    // 辅助函数：将值转换为数字，非数字返回0
    const toNumber = (val) => {
        if (val == null || val === '') return 0;
        const num = Number(val);
        return isNaN(num) ? 0 : num;
    };
    
    let directBurial = toNumber(bigObj.directBurial)
    let cableTrench = toNumber(bigObj.cableTrench)
    let pipeLaying = toNumber(bigObj.pipeLaying)
    let support = toNumber(bigObj.support)
    let cableTray = toNumber(bigObj.cableTray)
    let channel = toNumber(bigObj.channel)
    let cableOnPole = toNumber(bigObj.cableOnPole)
    let wireSpan = toNumber(bigObj.wireSpan)
    let layNoteCol = customColumnTitles.findIndex(el => el.fieldName == 'layNote')
    let directBurialIndex = customColumnTitles.findIndex(el => el.fieldName == 'directBurial')

    // console.log('bigObj', bigObj, bigObj1)
    
    // if(directBurial + cableTrench + pipeLaying + support + cableTray + channel + cableOnPole != wireSpan && bigObj1.writeType && bigObj1.writeType.type == 2) {
    //     if(bigObj.layNote != '电缆敷设长度与档距或总长（m）不一致，请复核') {
    //         luckysheet.setCellValue(row_index, layNoteCol,
    //         {
    //             v: '电缆敷设长度与档距或总长（m）不一致，请复核',
    //             m: '电缆敷设长度与档距或总长（m）不一致，请复核',
    //         },
    //         {upadtejfredo: false})
    //     }
    // } else if(bigObj.layNote) {
    //     luckysheet.setCellValue(row_index, layNoteCol, null,
    //     {upadtejfredo: false})
    // }
    // 如果是电缆,直埋=档距或总长-电缆沟(隧)道-排管内-沿支架、墙面卡设- 沿桥架- 竖直通道-电缆上杆或进-出设备柜
    let row_index1 = row_index == 0 || row_index % 2 == 0 ? row_index + 1 : row_index
    let newDirectBurial = numeral(wireSpan).subtract(cableTrench).subtract(pipeLaying).subtract(support).subtract(cableTray).subtract(channel).subtract(cableOnPole).value()
    if(bigObj1.writeType && bigObj1.writeType.type == 2 && (directBurial != newDirectBurial || (!bigObj.directBurial && newDirectBurial))) {
        luckysheet.setCellValue(row_index1, directBurialIndex,
            {
                v: newDirectBurial,
                m: newDirectBurial,
            },
            {upadtejfredo: false}
        )
        if(newDirectBurial < 0) {
            if(bigObj.layNote != '直埋(m)不能为负数') {
                luckysheet.setCellValue(row_index1, layNoteCol,
                {
                    v: '直埋(m)不能为负数',
                    m: '直埋(m)不能为负数',
                },
                {upadtejfredo: false})
            }
        } else if (bigObj.layNote == '直埋(m)不能为负数') {
            luckysheet.setCellValue(row_index1, layNoteCol, null,
                {upadtejfredo: false})
        }
    }
    
}

// 填充防火封堵材质
// 填充电缆调试说明
// 且为电缆情况下才需要校验 导线类型的 writeType.type == 2
// bigObj1.writeType && bigObj1.writeType.type == 2
function fullBlockingMaterial(row_index, d=Store.flowdata) {
    const customColumnTitles = luckysheetConfigsetting.customColumnTitles;
    let {
        bigObj = {},
        bigObj1 = {},
    } = getRowValue(row_index)
    let blockingMaterialIndex = customColumnTitles.findIndex(el => el.fieldName == 'blockingMaterial')
    if(bigObj1.writeType && bigObj1.writeType.type == 2) {
        if(!bigObj.blockingMaterial) {
            let value = luckysheetConfigsetting.projectData && luckysheetConfigsetting.projectData.globalConfig && luckysheetConfigsetting.projectData.globalConfig.fireproofMaterial ? luckysheetConfigsetting.projectData.globalConfig.fireproofMaterial : ''
            let row_index1 = row_index == 0 || row_index % 2 == 0 ? row_index + 1 : row_index
            let titleObj = customColumnTitles[blockingMaterialIndex]
            let showNameVal = titleObj.showNameVal ? titleObj.showNameVal.split('#&#') : ['val','key']
            
            luckysheet.setCellValue(row_index1, blockingMaterialIndex,
                {
                    v: value,
                    m: value,
                    saveVal: value,
                    saveObj: {
                      [showNameVal[1]]: value,
                      isDefault: true
                    },
                },
                {upadtejfredo: false}
            )
        }
        if(!bigObj.cableDescribe) {
            let cableDescribeIndex = customColumnTitles.findIndex(el => el.fieldName == 'cableDescribe')
            let cableDescribe = customColumnTitles[cableDescribeIndex]?.defaultVal
            let row_index1 = row_index == 0 || row_index % 2 == 0 ? row_index + 1 : row_index
            luckysheet.setCellValue(row_index1, cableDescribeIndex,
                {
                    v: cableDescribe,
                    m: cableDescribe,
                },
                {upadtejfredo: false}
            )
        }
    } else {
        if(bigObj.blockingMaterial) {
            let row_index1 = row_index == 0 || row_index % 2 == 0 ? row_index + 1 : row_index
            luckysheet.setCellValue(row_index1, blockingMaterialIndex,
                null,
                {upadtejfredo: false}
            )
        }
        if(bigObj.cableDescribe) {
            let cableDescribeIndex = customColumnTitles.findIndex(el => el.fieldName == 'cableDescribe')
            let row_index1 = row_index == 0 || row_index % 2 == 0 ? row_index + 1 : row_index
            luckysheet.setCellValue(row_index1, cableDescribeIndex,
                null,
                {upadtejfredo: false}
            )
        }
    }
}

/**
 * 默认填充
 * 电压等级
 */
function fullValue(row_index, d=Store.flowdata) {
    const customColumnTitles = luckysheetConfigsetting.customColumnTitles;
    let {
        bigObj = {},
    } = getRowValue(row_index)
    
    // let sgzsbyqVoltageLevelIndex = customColumnTitles.findIndex(el => el.fieldName == 'sgzsbyqVoltageLevel')
    // let dgzsbyqVoltageLevelIndex = customColumnTitles.findIndex(el => el.fieldName == 'dgzsbyqVoltageLevel')

    // if(!luckysheetConfigsetting.isEmptyString(bigObj.rodTowerNo)) {
    //     let value = '10kV'
    //     if(luckysheetConfigsetting.isEmptyString(bigObj.sgzsbyqVoltageLevel)) {
    //         let row_index1 = row_index == 0 || row_index % 2 == 0 ? row_index + 1 : row_index
    //         luckysheet.setCellValue(row_index1, sgzsbyqVoltageLevelIndex,
    //             {
    //                 v: value,
    //                 m: value,
    //             },
    //             {upadtejfredo: false}
    //         )
    //     }
    //     if(luckysheetConfigsetting.isEmptyString(bigObj.dgzsbyqVoltageLevel)) {
    //         let row_index1 = row_index == 0 || row_index % 2 == 0 ? row_index : row_index - 1
    //         luckysheet.setCellValue(row_index1, dgzsbyqVoltageLevelIndex,
    //             {
    //                 v: value,
    //                 m: value,
    //             },
    //             {upadtejfredo: false}
    //         )
    //     }
    // } else {
    //     console.log('没有杆塔编号，不填充电压等级')
    //     if(!luckysheetConfigsetting.isEmptyString(bigObj.sgzsbyqVoltageLevel)){
    //         let row_index1 = row_index == 0 || row_index % 2 == 0 ? row_index + 1 : row_index
    //         luckysheet.setCellValue(row_index1, sgzsbyqVoltageLevelIndex,
    //             null,
    //             {upadtejfredo: false}
    //         )
    //     }
    //     if(!luckysheetConfigsetting.isEmptyString(bigObj.dgzsbyqVoltageLevel)) {
    //         let row_index1 = row_index == 0 || row_index % 2 == 0 ? row_index : row_index - 1
    //         luckysheet.setCellValue(row_index1, dgzsbyqVoltageLevelIndex,
    //             null,
    //             {upadtejfredo: false}
    //         )
    //     }
    // }

    // 双干变 在选择成套后，备注自动显示： 柱上变压器台成套设备已包含接地材料。
    let sgzsbyqNoteCol = customColumnTitles.findIndex(el => el.fieldName == 'sgzsbyqNote')
    let row_index1 = row_index == 0 || row_index % 2 == 0 ? row_index + 1 : row_index
    if(bigObj.sgzsbyqIsComplete && bigObj.sgzsbyqIsComplete == '成套' && bigObj.sgzsbyqNote.indexOf('柱上变压器台成套设备已包含接地材料。') == -1) {
        luckysheet.setCellValue(row_index1, sgzsbyqNoteCol,
            {
                v: '柱上变压器台成套设备已包含接地材料。',
                m: '柱上变压器台成套设备已包含接地材料。',
            },
            {upadtejfredo: false})
    } else if((!bigObj.sgzsbyqIsComplete || bigObj.sgzsbyqIsComplete != '成套') && bigObj.sgzsbyqNote.indexOf('柱上变压器台成套设备已包含接地材料。') > -1) {
        luckysheet.setCellValue(row_index1, sgzsbyqNoteCol, 
            bigObj.sgzsbyqNote.replace('柱上变压器台成套设备已包含接地材料。', ''),
            {upadtejfredo: false})
    }
}

/**
 * 填充拉盘信息
 * 根据拉线型号和数量自动填充拉盘型号和数量
 */
function fillValueLapan(row_index, d=Store.flowdata) {
    console.log('fillValueLapan');
    const customColumnTitles = luckysheetConfigsetting.customColumnTitles;
    const type = [
        {val: 'vl', hasTow: false},
        {val: 'pl', hasTow: false},
        {val: 'gl', hasTow: false},
        {val: 'spl', hasTow: false},
        {val: 'yl', hasTow: false},
        {val: 'sgl', hasTow: true},
    ]
    let {
        bigObj = {},
        bigObj1 = {},
    } = getRowValue(row_index)
    type.forEach(item => {
        const {val, hasTow} = item
        let obj = bigObj1[`${val}ModuleId`]
        let lxCount = bigObj[`${val}LxCount`]

        let materialArr = obj && obj.materialVOList && obj.materialVOList.length ? obj.materialVOList.sort((a, b) => b.materialId - a.materialId) : []
        let materialObj1 = materialArr[0]
        let materialId1 = materialObj1 && materialObj1.materialId
        let moduleName1 = materialObj1 && materialObj1.detailCode
        let moduleCount1 = materialObj1 && materialObj1.count
        let lpCount1 = numeral(moduleCount1).multiply(lxCount).value()

        let materialObj2 = materialArr[1]
        let materialId2 = materialObj2 && materialObj2.materialId
        let moduleName2 = materialObj2 && materialObj2.detailCode
        let moduleCount2 = materialObj2 && materialObj2.count
        let lpCount2 = numeral(moduleCount2).multiply(lxCount).value()
        
        if(
            !luckysheetConfigsetting.isEmptyString(bigObj[`${val}ModuleId`]) &&
            !luckysheetConfigsetting.isEmptyString(lxCount)
        ) {
            let keyArr = [
                {key: 'MaterialId', name: `${val}MaterialId${hasTow ? '1': ''}`, num: 1},
                // {key: 'LpCount', name: `${val}LpCount${hasTow ? '1': ''}`, num: 1},
            ]
            if(hasTow && materialObj2) {
                keyArr.push({key: 'MaterialId', name: `${val}MaterialId2`, num: 2})
                // keyArr.push({key: 'LpCount', name: `${val}LpCount2`, num: 2})
            }
            keyArr.forEach(el => {
                let moduleName = el.num == 1 ? moduleName1 : moduleName2
                let materialId = el.num == 1 ? materialId1 : materialId2
                let materialObj = el.num == 1 ? materialObj1 : materialObj2
                let lpCount = el.num == 1 ? lpCount1 : lpCount2
                console.log('对象', bigObj1[el.name], moduleName)
                if(
                    luckysheetConfigsetting.isEmptyString(bigObj[el.name]) ||
                    (
                        bigObj1[el.name] && bigObj1[el.name].isDefault &&
                        bigObj[el.name] != materialId &&
                        materialId
                    )
                ) {
                    let rowIndex = row_index
                    let colIndex1 = customColumnTitles.findIndex(v => v.fieldName == el.name)
                    let colIndex2 = customColumnTitles.findIndex(v => v.fieldName == `${val}LpCount${hasTow ? el.num: ''}`)
                    
                    let titleObj = customColumnTitles[colIndex1]
                    if(titleObj && titleObj.isMerge == 1) {
                        rowIndex = row_index == 0 || row_index % 2 == 0 ? row_index + 1 : row_index
                    } else {
                        rowIndex = row_index == 0 || row_index % 2 == 0 ? row_index : row_index - 1
                    }
                    // if(el.key == 'MaterialId') {
                        luckysheet.setCellValue(rowIndex, colIndex1,
                        {
                            v: moduleName,
                            m: moduleName,
                            saveVal: materialId,
                            saveObj: { ...materialObj, isDefault: true },
                            // saveObj: materialObj,
                        },
                        {upadtejfredo: false})
                    // } else {
                        luckysheet.setCellValue(rowIndex, colIndex2,
                        {
                            v: lpCount,
                            m: lpCount,
                        },
                        {upadtejfredo: false}) 
                    // }
                }    
            })
        }
    })
}

// 页面端条件错误导致的杆型无法匹配的提示词
function fontCheck(row_index, d=Store.flowdata) {
    let fontCheckOpction = luckysheetConfigsetting.fontCheckOpction
    let {
        bigObj = {},
        bigObj4 = {}
    } = getRowValue(row_index)
    let geoConfig = bigObj4.geoConfig || {}

    let keys = Object.keys(fontCheckOpction[0])
    keys.pop()
    let isFlag = false
    let wireNote = ''
    fontCheckOpction.forEach((item) => {
        let flag = keys.every(el => {
            let v = item[el] ? item[el].split('#&#') : []
            return ( bigObj[el] && item[el] && v.includes(bigObj[el]) ) ||
            ( geoConfig[el] && geoConfig[el] && v.includes(geoConfig[el]) )
        })
        if(flag) {
          isFlag = true
          wireNote = item.marks
        }
    })
    return {isFlag, wireNote}
    // let wireNoteIndex = luckysheetConfigsetting.customColumnTitles.findIndex(v => v.fieldName == 'wireNote')
    // if(isFlag && bigObj['wireNote'] != wireNote) {
    //     luckysheet.setCellValue(row_index, wireNoteIndex,
    //     {
    //         v: wireNote,
    //         m: wireNote,
    //     },
    //     {upadtejfredo: false})
    // } else if(!isFlag && bigObj['wireNote']) {
    //     luckysheet.setCellValue(row_index, wireNoteIndex,
    //     null,
    //     {upadtejfredo: false})
    // }
}

/**
 *当是否配置塔腿都等于否时，在宽基塔塔腿中宽基塔A腿高、宽基塔B腿高、宽基塔C腿高、宽基塔D腿高填入0且不能修改
 isConfigLeg == '否' 清除信息,且不让填充
 isConfigLeg == '是' 填写0,且允许修改
 */
function fullValueLeg(row_index, d=Store.flowdata) {
    let fullCell = ['legA', 'legB', 'legC', 'legD']
    const customColumnTitles = luckysheetConfigsetting.customColumnTitles;
    let {
        bigObj = {},
        bigObj1 = {},
    } = getRowValue(row_index)
    let rodTypeModuleIdObj = bigObj1['rodTypeModuleId'] ? bigObj1['rodTypeModuleId'] : {}
    let isConfigLeg = rodTypeModuleIdObj && rodTypeModuleIdObj.isConfigLeg ? rodTypeModuleIdObj.isConfigLeg : ''
    if(bigObj['rodTowerMaterial'] == '宽基塔') {
        if(isConfigLeg == '否') {
            fullCell.forEach(el => {
                if(luckysheetConfigsetting.isEmptyString(bigObj[el]) || bigObj[el]) {
                    let colIndex = customColumnTitles.findIndex(v => v.fieldName == el)
                    let titleObj = customColumnTitles[colIndex]
                    let rowIndex = row_index
                    if(titleObj && titleObj.isMerge == 1) {
                        rowIndex = row_index == 0 || row_index % 2 == 0 ? row_index + 1 : row_index
                    } else {
                        rowIndex = row_index == 0 || row_index % 2 == 0 ? row_index : row_index - 1
                    }
                    luckysheet.setCellValue(rowIndex, colIndex,
                    null,
                    {upadtejfredo: false}) 
                }
            })
        } else {
            fullCell.forEach(el => {
                if(luckysheetConfigsetting.isEmptyString(bigObj[el]) || bigObj[el] != 0) {
                    let colIndex = customColumnTitles.findIndex(v => v.fieldName == el)
                    let titleObj = customColumnTitles[colIndex]
                    let rowIndex = row_index
                    if(titleObj && titleObj.isMerge == 1) {
                        rowIndex = row_index == 0 || row_index % 2 == 0 ? row_index + 1 : row_index
                    } else {
                        rowIndex = row_index == 0 || row_index % 2 == 0 ? row_index : row_index - 1
                    }
                    luckysheet.setCellValue(rowIndex, colIndex,
                    {
                        v: '0',
                        m: '0',
                        saveVal: '0'
                    },
                    {upadtejfredo: false}) 
                }
            })
        }
    }
}
/**
 * 滚动到指定行列
 * @param {number} rowIndex 行索引
 * @param {number} colIndex 列索引
 * */
function scrollRange(rowIndex, colIndex) {
    if (rowIndex == null || colIndex == null) {
        return;
    }

    if (typeof luckysheet !== "undefined" && typeof luckysheet.scroll === "function") {
        luckysheet.scroll({ targetRow: rowIndex });
    }

    const titles = luckysheetConfigsetting.customColumnTitles || [];
    const columnConfig = titles[colIndex];
    if (!columnConfig) {
        return;
    }
    // 例: paramType = 设计参数 optionType = 杆塔及导线
    const { paramType, optionType } = columnConfig;
    const panels = luckysheetConfigsetting.tabPanel || [];

    const panel = panels.find((item) =>
        item.paramType === paramType &&
        item.optionType === optionType
    );

    if (panel) {
        tabChange(panel.type, panel.key);
    }
}

/***
 * @description: 检查高度
 * @param startR 开始行 endR结束行
 */
export function checkHeight(startR = 0, endR = Store.flowdata.length - 1) {
    // let cfg = $.extend(true, {}, Store.config);
    // cfg = rowlenByRange(Store.flowdata, startR, endR, cfg);
    // Store.config = cfg
    // let file = Store.luckysheetfile[getSheetIndex(Store.currentSheetIndex)];file.config = Store.config;
    // rhchInit(Store.flowdata.length, Store.flowdata[0].length)
    luckysheetrefreshgrid(null, null, false, true);
}

export {
    seletedHighlistByindex,
    selectHightlightShow,
    selectOperationShow,
    selectIsOverlap,
    selectionCopyShow,
    collaborativeEditBox,
    luckysheet_count_show,
    selectHelpboxFill,
    fullErrorRow,
    clearErrorRow,
    drawError,
    showMessage,
    editRelateCell,
    isEditRow,
    fullCellTower,
    fillDefaultVal,
    getMerge,
    checkLength,
    scrollRange,
    fullBlockingMaterial,
    fullValue,
    fillValueLapan,
    fullValueLeg,
    fontCheck,
}
